import { useOperatorStore } from '@/core/stores/operator-store';
import { formatCurrency, formatCurrencyRight } from '../utils/currency-utils';

/**
 * Returns a formatCurrency function bound to the selected operator's currency.
 * Falls back to 'ILS' if currency is not set.
 */
export function useCurrencyFormatter() {
  const currency = useOperatorStore((state) => state.selectedOperator?.currency) ?? 'ILS';
  return (value: number) => formatCurrency(value, currency);
}

/**
 * Same as useCurrencyFormatter but places the symbol on the right (e.g. 17.2$).
 */
export function useCurrencyFormatterRight() {
  const currency = useOperatorStore((state) => state.selectedOperator?.currency) ?? 'ILS';
  return (value: number) => formatCurrencyRight(value, currency);
}
